
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blogs",
      function () {
        return require("private-next-pages/c/blogs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blogs"])
      });
    }
  